// extracted by mini-css-extract-plugin
module.exports = {"activation_img":"_31GoJ","activation_read":"_2285S","case_study_slider":"oaQdE"};